<div class="modal-header">
    <h5 class="modal-title" id="editCompanyTitle">Edit Directory Info</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageCompanyDirectoryInfoForm">
        <div class="row">
            <div class="col-md-12 mb-3">
                <label for="description" class="form-label">Short Company Description</label>
                <editor formControlName="description" class="form-control" initialValue="company.description" licenseKey="gpl" [init]="{
                    base_url: '/tinymce',
                    suffix: '.min',
                    menubar: false,
                    statusbar: false,
                    toolbar: false,
                    height: 200,
                    skin: '../../../assets/css/tinymce',
                    content_style: 'body { color: #FFFFFF; }',
                }"></editor>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 mb-3">
                <label for="logo" class="form-label">Logo Image <a href="javascript:void(0);" class="formTooltip" placement="top" ngbTooltip="Allowed file types: jpeg, jpg, png, webp."><i class="fa-solid fa-circle-question"></i></a></label>
                <input (change)="updateLogoImage($event)" class="form-control" type="file" id="logo">
            </div>
        </div>
        <div class="row" *ngIf="isCompanyLiaison">
            <div class="col-12 mb-3">
                <div class="form-check">
                    <input formControlName="directoryOptIn" class="form-check-input" type="checkbox" id="directoryOptIn">
                    <label for="directoryOptIn" class="form-label">Show Liaison Info on Directory <a href="javascript:void(0);" class="formTooltip" placement="top" ngbTooltip="You must be opted in to see liaison info of other members."><i class="fa-solid fa-circle-question"></i></a></label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="website" class="form-label">Company/Organization Website</label>
                <input formControlName="website" type="text" class="form-control" id="website" placeholder="website">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="save()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
</div>